import { useEffect } from "react";

function scrollToHashElement(hash) {
  const id = hash.replace("#", "");
  const element = document.getElementById(id);
  if (!element) return;

  const supportsSmoothScroll =
    "scrollBehavior" in document.documentElement.style;

  if (supportsSmoothScroll) {
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    element.scrollIntoView();
  }
}

export function useHashScroll(location) {
  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace("#", "");
    let attempts = 0;
    const maxAttempts = 20;
    const intervalDelay = 200;

    const intervalId = setInterval(() => {
      const element = document.getElementById(id);
      attempts++;

      if (element) {
        scrollToHashElement(location.hash);
        clearInterval(intervalId); // Stop polling
      } else if (attempts >= maxAttempts) {
        clearInterval(intervalId); // Stop polling even if not found
      }
    }, intervalDelay);

    // Cleanup interval on component unmount or hash change
    return () => clearInterval(intervalId);
  }, [location]);
}
